export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'

export const GET_USER_INFO = 'GET_USER_INFO'

export const CLIENT_SELF_UPDATE = 'CLIENT_SELF_UPDATE'

export const GET_CLIENT = 'GET_CLIENT'
export const GET_CLIENTS = 'GET_CLIENTS'

export const UPDATE_CLIENT = 'UPDATE_CLIENT'
export const SET_MANAGER_CURRENT_CLIENT = 'SET_MANAGER_CURRENT_CLIENT'


export const UPDATE_USER_PAYMENT = 'UPDATE_PAYMENT'

export const GET_GENERAL_SETTINGS = 'GET_GENERAL_SETTINGS'
export const PUT_GENERAL_SETTINGS = 'PUT_GENERAL_SETTINGS'


export const GET_MAILING_TEMPLATES = 'GET_MAILING_TEMPLATES'
export const SEND_MAIL = 'SEND_MAIL'

